<template>
	<div id="page_1">
		<div class="title">
			<p>选择‘酷联客’物联网应用方案，唯快不破</p>
			<p class="sub">我们专业提供设备智能化、物联网控制解决方案</p>
		</div>
		<img class="img_material" :src="img.material" />
		<img class="img_next" :src="img.next"  @click="$store.state.oHomePage.index += 1"/>
	</div>
</template>
<script>
	
	export default {
		data() {
			return {
				img:{
					material:require("@/assets/img/home/benner_material_1.png"),
					next:require("@/assets/img/home/toNext.png")
				}
			}
		},
		computed: {
		},
		methods: {
		},
		components: {			
		},
		created() {
		}
	}
</script>
<style lang="less">
	@import url("../../assets/common.less");
	#page_1{
		.page();
		background-image:linear-gradient(-100deg, #385f81 20%, #212930 100%);
		& > .title{
			.page_title(@color:@font-color-white);
		}
		& > img{			
			position:absolute;
			left: 0;
			right: 0;
			margin: 0 auto;
			&.img_material{
	    		height: 45vh;
				top: 40vh;
				width: auto;
			}
			&.img_next{
				width: 2em;
				height: 1em;
				bottom: 2em;
				cursor: pointer;
				animation: toNext 0.4s ease-in infinite alternate;
				@keyframes toNext{
					from{bottom: 30px;}
					to{bottom: 20px;}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// page_1.vue?03e84c00